// Organization types matching admin-web structure

export interface IPaymentAccount {
  name: string;
  debit: boolean;
  description: string;
  accountNumber: string | null;
}

export interface IEntrataUser {
  username: string;
  password: string;
}

export interface ICreateOrganization {
  name: string;
  domain: string;
  paymentAccounts: IPaymentAccount[];
}

export interface IOrganization extends ICreateOrganization {
  id: number;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

export interface IOrganizationRowData {
  id: number;
  name: string;
  domain: string;
  createdAt: string;
}

// Keys shown in the table header
export enum OrganizationKeys {
  name = "name",
  domain = "domain",
  createdAt = "createdAt",
}

export interface IOrganizationFormValues {
  name: string;
  domain: string;
  paymentAccounts: IPaymentAccount[];
  entrataUsers?: IEntrataUser[];
}

export const defaultOrganizationFormValues: IOrganizationFormValues = {
  name: "",
  domain: "",
  entrataUsers: [],
  paymentAccounts: [
    {
      name: "totalfunding",
      debit: true,
      description: "Total Funding",
      accountNumber: null,
    },
    {
      name: "netsales_ledger_amount",
      debit: false,
      description: "Ledger Amount",
      accountNumber: null,
    },
    {
      name: "netsales_convenience_fee",
      debit: false,
      description: "Convenience Fee",
      accountNumber: null,
    },
    {
      name: "netsales_other",
      debit: false,
      description: "Net Sales Other",
      accountNumber: null,
    },
    {
      name: "refund_ledger_amount",
      debit: false,
      description: "Refund Ledger Amount",
      accountNumber: null,
    },
    {
      name: "refund_convenience_fee",
      debit: false,
      description: "Refund Convenience Fee",
      accountNumber: null,
    },
    {
      name: "refund_other",
      debit: false,
      description: "Refund Other",
      accountNumber: null,
    },
    {
      name: "reversal",
      debit: false,
      description: "Reversal",
      accountNumber: null,
    },
    {
      name: "fee",
      debit: false,
      description: "Fee",
      accountNumber: null,
    },
    {
      name: "interchangefee",
      debit: false,
      description: "Interchange Fee",
      accountNumber: null,
    },
    {
      name: "adjustment",
      debit: false,
      description: "Adjustment",
      accountNumber: null,
    },
    {
      name: "servicecharge",
      debit: false,
      description: "Service Charge",
      accountNumber: null,
    },
    {
      name: "otheradjustment",
      debit: false,
      description: "Other Adjustment",
      accountNumber: null,
    },
    {
      name: "thirdparty",
      debit: false,
      description: "Third Party",
      accountNumber: null,
    },
  ],
};

// API response types
export interface IOrganizationListResponse {
  success: boolean;
  response: {
    rows: IOrganization[];
  };
}

export interface IOrganizationDetailsResponse {
  success: boolean;
  response: IOrganization;
}

export interface IOrganizationApiResponse {
  success: boolean;
  response?: any;
  message?: string;
}

